"use client";

import { AppProgressProvider as ProgressProvider } from "@bprogress/next";
import { colors } from "@/utils/library/colors";

export default function BProgressProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ProgressProvider color={colors.primary} shallowRouting>
      {children}
    </ProgressProvider>
  );
}
